import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { Checkbox, createFilterOptions } from '@mui/material'
import { default as TextFieldMui } from '@mui/material/TextField'
import { Autocomplete, AutocompleteProps } from './Autocomplete'

export interface ShippingPointsAutoCompleteProps
  extends Omit<AutocompleteProps, 'options' | 'renderInput'> {
  shippingPointData: any
  selectedShippingPoints: any
}

export const ShippingPointsAutocomplete = ({
  name,
  shippingPointData,
  selectedShippingPoints,
  ...rest
}: ShippingPointsAutoCompleteProps) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />

  const countryFilterOptions = createFilterOptions({
    ignoreCase: true,
    stringify: (option: any) => option.value + option.label,
  })

  return (
    <Autocomplete
      name={name}
      multiple
      options={shippingPointData}
      limitTags={3}
      disableCloseOnSelect
      filterOptions={countryFilterOptions}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.value}
      value={selectedShippingPoints}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option?.label}
        </li>
      )}
      renderInput={(params) => (
        <TextFieldMui
          {...params}
          placeholder={
            selectedShippingPoints && selectedShippingPoints.length === 0
              ? 'Select Shipping Point'
              : ''
          }
        />
      )}
      {...rest}
    />
  )
}
